import styled from 'styled-components';

export const LoginContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;

    &, > div {
        height: 100vh;
    }

    header {
        position: absolute;
        top: 0;
        left: 0;
        /* right: 0; */
        z-index: 10;

        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 50vw;
        padding: 3rem 5rem;

        font-size: 1.4rem;
        font-weight: 600;

        span {
            cursor: pointer;
        }

        i {
            margin-right: 1rem;
        }
    }

    .swiper-container {
        width: 50vw;

        .swiper-button-next, .swiper-button-prev {
            display: none;
        }

        .swiper-slide {
            position: relative;
            
            min-height: 100vh;

            overflow: hidden;

            img {
                position: absolute;
                z-index: 1;

                width: 100%;
                height: 100%;

                object-fit: cover;
            }

            .shadow {
                position: absolute;
                z-index: 2;

                width: 100%;
                height: 100%;
                opacity: .5;

                background: #000;
            }
        }
    }

    .login-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        
        &::-webkit-scrollbar {
            width: 0.5vw;
            background: transparent;
            padding-right: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #000; 
        }

        .form-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            width: 45rem;

            .heading {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;

                > img {
                    display: none;
                    height: 3.5rem;
                    object-fit: contain;
                    margin-bottom: 3rem;
                }

                h1 {
                    font-size: 3rem;
                    font-weight: bold;
                    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
                }
            }

            form {
                width: 45rem;
                margin: 5rem 0;

                .group-input {
                    display: flex;
                    align-items: center;
                    margin-top: 3rem;

                    .input {
                        flex: 1;
                        width: auto;

                        + .input {
                            margin-top: 0;
                            margin-left: 3rem;
                        }
                    }
                }

                .button {
                    width: 100%;
                    height: 4.5rem;
                    margin-top: 5rem;
                }
            }

            .has-account {
                width: 100%;
                text-align: center;
                
                .or {
                    position: relative;

                    width: 60%;
                    height: 2px;
                    margin: 0 auto 4rem;

                    &::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);

                        width: 100%;
                        height: 1px;

                        background: rgba(0, 0, 0, .3);
                    }

                    &::after {
                        content: 'Ou';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);

                        padding: 0 .6rem;

                        font-size: 1.4rem;
                        font-weight: 600;

                        background: #fff;
                        color: rgba(0, 0, 0, .5);
                    }
                }

                a {
                    font-size: 1.6rem;

                    &:hover {
                        color: #000;
                    }
                }
            }
        }
    }

    .messages-container {
        position: fixed;
        top: 5rem;
        right: 5rem;
        z-index: 1000;

        pointer-events: none;

        .status-message {
            position: relative;
            display: flex;

            height: auto;
            width: 25rem;
            padding: 1rem;
            padding-left: 2rem;
            margin-bottom: 2rem;

            background: #fff;
            border: 1px solid rgba(0, 0, 0, .1);
            border-radius: 1rem;
            box-shadow: 1rem 1rem 3rem rgba(0, 0, 0, .1);
            pointer-events: auto;

            opacity: 0;

            &.error {
                border-left: 5px solid #ff0033;
            }

            &.success {
                border-left: 5px solid #4BB543;
            }

            i {
                position: absolute;
                top: 1.4rem;
                right: 1.8rem;

                display: flex;
                align-items: center;
                justify-content: center;

                width: 1rem;
                height: 1rem;

                font-size: 1.3rem;
                color: rgba(0, 0, 0, .3);

                cursor: pointer;

                &:hover {
                    color: #000;
                }
            }

            .text {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;

                strong {
                    font-size: 1.3rem;
                    margin-bottom: .5rem;
                    color: #000;
                }

                span {
                    font-size: 1.2rem;
                }
            }
        }

        @keyframes enterAnimation {
            0% {
                opacity: 0;
                transform: translateX(150%);
            }

            80% {
                opacity: 1;
            }

            90% {
                transform: translateX(-2%);
            }

            100% {
                opacity: 1;
                transform: translateX(0);
            }
        }

        @keyframes outAnimation {
            0% {
                opacity: 1;
                max-height: 7.9rem;
                pointer-events: none;
            }

            10% {
                opacity: 0;
            }

            100% {
                opacity: 0;
                max-height: 0;
                margin-bottom: 0;
                padding: 0;
            }
        }
    }

    @media (max-width: 540px) {
        flex-direction: column;
        min-height: 100vh;

        &, > div {
            height: unset;
        }
    
        header {
            top: 35vh;

            width: 100%;
            padding: 3rem 7%;

            font-size: 12px;
        }

        .swiper-container {
            width: 100vw;
            height: 35vh;

            .swiper-slide {
                min-height: unset;
                height: 35vh;
                width: 100vw;

                img {
                    object-position: 100% 30%;
                }
            }
        }

        .login-content {
            width: 90%;
            padding: 17rem 0;

            .form-container {
                width: 100%;

                .heading {
                    > img {
                        height: 6.94444vw;
                    }

                    h1 {
                        font-size: 5.55556vw;
                    }
                }

                form {
                    width: 90%;
                    margin: 9.72222vw 0 16.66667vw;

                    .group-input {
                        flex-direction: column;
                        margin-top: 8.33333vw;

                        .input {
                            flex: unset;
                            width: 100%;

                            + .input {
                                margin-top: 8.33333vw;
                                margin-left: 0;
                            }
                        }
                    }

                    .button {
                        height: 11.11111vw;
                        margin-top: 13.88889vw;
                    }
                }
            
                .has-account {
                    .or {
                        margin: 0 auto 11.11111vw;

                        &::after {
                            font-size: 2.77778vw;
                        }
                    }

                    a {
                        font-size: 3.88889vw;
                    }
                }
            }
        }

        .messages-container {
            top: 13.88889vw;
            right: 5%;

            .status-message {
                width: 64vw;
                padding: 1.94444vw;
                padding-left: 2.77778vw;
                margin-bottom: 4.16667vw;

                i {
                    right: 1.94167vw;
                    width: 2.77778vw;
                    height: 2.77778vw;
                    font-size: 2.77778vw;
                }

                .text {
                    strong {
                        font-size: 3.07778vw;
                        margin-bottom: 0.55556vw;
                    }

                    span {
                        font-size: 2.52222vw;
                    }
                }
            }
        }
    }
`;
